export function convertPercentsToCol(percent) {
  switch (percent) {
    case '25%':
      return 'col-3';
    case '50%':
      return 'col-6';
    case '75%':
      return 'col-9';
    case '100%':
      return 'col-12';
  }
};


// WEBPACK FOOTER //
// ./src/helpers/woGrid.js